import React from 'react'
import VirtualTourBanner from '../../components/virtualTour/virtualTourBanner'
import Header from "../../shared/header"
import PagesFooter from "../../shared/pagesFooter"
const VirtualTourPage = () => {
  return (
    <div>
      <div className='virtual-tour-header'>
        <Header />
      </div>
      <VirtualTourBanner />
      <PagesFooter/>
    </div>
  )
}

export default VirtualTourPage